import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import withLoader from "../../components/layouts/WithLoader";
import { Alert } from "@material-ui/lab";
import { Snackbar, TextField } from "@material-ui/core";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import configEmailService from "../../services/PosService/ConfigEmailService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRemove, faTrash } from "@fortawesome/free-solid-svg-icons";

const styles = {
  container: (base) => ({
    ...base,
    flex: 1,
  }),
};
const AddConfigEmailsSociete = ({ startLoading, stopLoading }) => {
  const navigate = useNavigate();
  const [configSociete, setConfigSociete] = useState([]);

  const [emailToAdd, setEmailToAdd] = useState("");
  //selection
  const TypeOptions = [
    { value: "production", label: "production" },
    { value: "shop", label: "shop" },
  ];
  const [typeSelected, setTypeSelected] = useState("production");
  const handleChangeSelected = (event) => {
    setTypeSelected(event.target.value);
  };
  //alert
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState("");
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState("");
  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };
  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };

  const handleChange = (event) => {
    setEmailToAdd(event.target.value);
  };
  function isEmpty(value) {
    return value == null || value === "" || value === undefined;
  }
  const addconfigurationEmailBySociete = (e) => {
    if (isEmpty(emailToAdd)) {
      setOpenErrorAlert(true);
      setErrorAlertText("Veuillez remplir le champs email");
      return;
    }
    startLoading();
    configEmailService
      .addconfigurationEmailBySociete(
        getCurrentUserId(),
        emailToAdd,
        typeSelected
      )
      .then((response) => {
        if (response.data.success) {
          setOpenSuccessAlert(true);
          setSuccessAlertText(response.data.success);
          setConfigSociete({});
        } else if (response.data.error) {
          setOpenSuccessAlert(true);
          setSuccessAlertText(response.data.error);
        }
      })
      .catch((e) => {
        console.log("error", e);
      })
      .finally(() => {
        stopLoading();
      });
  };
  const handleRemove = (email, typeTable) => {
    startLoading();
    configEmailService
      .removeEmailBySociete(getCurrentUserId(), email, typeTable)
      .then((response) => {
        if (response.data.success) {
          setOpenSuccessAlert(true);
          setSuccessAlertText(response.data.success);
          window.location.reload();
        } else if (response.data.error) {
          setOpenSuccessAlert(true);
          setSuccessAlertText(response.data.error);
        }
      })
      .catch((e) => {
        console.log("error", e);
      })
      .finally(() => {
        stopLoading();
      });
  };
  useEffect(() => {
    startLoading();
    configEmailService
      .getconfigurationEmailBySociete(getCurrentUserId())
      .then((response) => {
        if (response.data.success) {
          setConfigSociete(response.data.success);
        } else if (response.data.error) {
          setOpenSuccessAlert(true);
          setSuccessAlertText(response.data.error);
        }
      })
      .catch((e) => {
        console.log("error", e);
      })
      .finally(() => {
        stopLoading();
      });
  }, []);

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div class="card card-dark">
            <div className="card-header">
              <h5 className="card-title">Ajouter Configuration de Societe</h5>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="form-group">
                    <label htmlFor="inputName">Ajouter email</label>
                    <input
                      onChange={handleChange}
                      type="text"
                      id="inputName"
                      className="form-control"
                      name="email"
                      placeholder="saisir email"
                      value={emailToAdd || ""}
                    />
                  </div>
                </div>
                <div className="col-sm-12">
                  <div className="form-group">
                    <label htmlFor="inputype">Choisir le type *</label>
                    <select
                      id="inputype"
                      name="type"
                      className="form-control"
                      onChange={handleChangeSelected}
                      value={typeSelected}
                    >
                      {TypeOptions.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div className="card-footer">
              <div className="col-sm-12  text-right">
                <button
                  className="btn btn-dark"
                  onClick={addconfigurationEmailBySociete}
                >
                  Confirmer configuration
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="content-header">
        <div className="container-fluid">
          <div class="card card-secondary">
            <div className="card-header">
              <h5 className="card-title">Emails Shops</h5>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-sm-12">
                  <table className="table styled-table">
                    <thead>
                      <tr>
                        <th>Email</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {configSociete.emailsShop && configSociete.emailsShop.length > 0 ? (
                        configSociete.emailsShop.map((email, index) => (
                          <tr key={index}>
                            <td>{email || ""}</td>
                            <td>
                              <button
                                onClick={() => handleRemove(email, "shop")}
                                className="btn btn-danger"
                              >
                                <FontAwesomeIcon icon={faTrash} />
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={2}>pas d'emails shop</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="content-header">
        <div className="container-fluid">
          <div class="card card-secondary">
            <div className="card-header">
              <h5 className="card-title">Emails Productions</h5>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-sm-12">
                  <table className="table styled-table">
                    <thead>
                      <tr>
                        <th>Email</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {configSociete.emailsProdutions && configSociete.emailsProdutions.length > 0 ? (
                        configSociete.emailsProdutions.map((email, index) => (
                          <tr key={index}>
                            <td>{email || ""}</td>
                            <td>
                              <button
                                onClick={() =>
                                  handleRemove(email, "production")
                                }
                                className="btn btn-danger"
                              >
                                <FontAwesomeIcon icon={faTrash} />
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={2}>pas d'emails production</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default withLoader(AddConfigEmailsSociete);
